import { axiosInstance } from "@/helper/axios-instance";
import type { DataAwareResponse, SystemSettings } from "../types/types";
import { useMutationWithValidation } from "@/hooks/useMutationWithValidation";

export function useUpdateSystemSettings() {
  return useMutationWithValidation<SystemSettings, Partial<SystemSettings>>({
    mutationFn: async (data: Partial<SystemSettings>) => {
      const response = await axiosInstance({
        method: "PUT",
        url:  `Security/UpdateSettings`,
        data: data,
      });

      return response.data as DataAwareResponse<SystemSettings>;
    },
  });
}
